import React from "react";

interface IProps {
  theme: "light" | "dark";
}

export const PauseIcon = ({ theme }: IProps) => {
  return (
    <div>
      {theme === "light" ? (
        <svg
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_10388_151313)">
            <path
              d="M27.5 0.859375C12.7832 0.859375 0.859375 12.7832 0.859375 27.5C0.859375 42.2168 12.7832 54.1406 27.5 54.1406C42.2168 54.1406 54.1406 42.2168 54.1406 27.5C54.1406 12.7832 42.2168 0.859375 27.5 0.859375ZM25.7812 36.0938C25.7812 37.0391 25.0078 37.8125 24.0625 37.8125H18.9062C17.9609 37.8125 17.1875 37.0391 17.1875 36.0938V18.9062C17.1875 17.9609 17.9609 17.1875 18.9062 17.1875H24.0625C25.0078 17.1875 25.7812 17.9609 25.7812 18.9062V36.0938ZM37.8125 36.0938C37.8125 37.0391 37.0391 37.8125 36.0938 37.8125H30.9375C29.9922 37.8125 29.2188 37.0391 29.2188 36.0938V18.9062C29.2188 17.9609 29.9922 17.1875 30.9375 17.1875H36.0938C37.0391 17.1875 37.8125 17.9609 37.8125 18.9062V36.0938Z"
              fill="#233851"
            />
          </g>
          <defs>
            <clipPath id="clip0_10388_151313">
              <rect width="55" height="55" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.5 0.859375C12.7832 0.859375 0.859375 12.7832 0.859375 27.5C0.859375 42.2168 12.7832 54.1406 27.5 54.1406C42.2168 54.1406 54.1406 42.2168 54.1406 27.5C54.1406 12.7832 42.2168 0.859375 27.5 0.859375ZM25.7812 36.0938C25.7812 37.0391 25.0078 37.8125 24.0625 37.8125H18.9062C17.9609 37.8125 17.1875 37.0391 17.1875 36.0938V18.9062C17.1875 17.9609 17.9609 17.1875 18.9062 17.1875H24.0625C25.0078 17.1875 25.7812 17.9609 25.7812 18.9062V36.0938ZM37.8125 36.0938C37.8125 37.0391 37.0391 37.8125 36.0938 37.8125H30.9375C29.9922 37.8125 29.2188 37.0391 29.2188 36.0938V18.9062C29.2188 17.9609 29.9922 17.1875 30.9375 17.1875H36.0938C37.0391 17.1875 37.8125 17.9609 37.8125 18.9062V36.0938Z"
            fill="#329EE2"
          />
        </svg>
      )}
    </div>
  );
};
